import InfoPage, { InfoSection } from "@/components/InfoPage";
import { COMPANY } from "@/data/site";

const Policies = () => (
  <InfoPage eyebrow="Our Policies" title="Shipping, returns & refunds." updated="October 2026" testId="policies-page">
    <InfoSection heading="Shipping">
      <p>We ship across India through Shiprocket's courier partners. Shipping is free on all orders.</p>
      <p>Orders are usually dispatched within 1–2 working days and arrive within 3–7 working days, depending on your location. You'll get a tracking link by email as soon as your order ships, and you can follow it from My Account.</p>
    </InfoSection>

    <InfoSection heading="Cancellations">
      <p>You can cancel an order any time before it ships by writing to {COMPANY.email} with your order number. We'll refund you in full.</p>
      <p>Subscriptions can be paused or cancelled any time before the next renewal.</p>
    </InfoSection>

    <InfoSection heading="Returns">
      <p>DNA bars are a food product, so for reasons of hygiene and food safety we do not accept returns or offer refunds once an order has been delivered.</p>
    </InfoSection>

    <InfoSection heading="Refunds">
      <p>Refunds apply only to orders cancelled before they ship. They go back to your original payment method within 5–7 working days, and any loyalty points used on the order are returned to your account.</p>
    </InfoSection>
  </InfoPage>
);

export default Policies;
